'use strict';
const Notification = require('./index');

module.exports = Notification.extend({}, {
    type: 'action:work:create'
});



// WEBPACK FOOTER //
// ./notify/domain/entity/notification/actionwork/create.js